module.exports = __webpack_public_path__ + "img/fox_thumbnail.a67cfe91.jpg";